import type { AnyRecentItem } from '@recruitee/dashboard-types';
import { createSingleEntityStore } from '@recruitee/ngrx';

const { namespace, actions, reducer, selectors } = createSingleEntityStore<AnyRecentItem[]>()(
  'RecentItems',
  {
    customActions: adapter => ({
      update: (state, payload: Pick<AnyRecentItem, 'id' | 'type'>) => adapter.markAsPending(state),
      updateSuccess: state => adapter.markAsLoaded(state),
    }),
  },
);

export {
  namespace as DashboardRecentsNamespace,
  actions as DashboardRecentsActions,
  reducer as DashboardRecentsReducer,
  selectors as DashboardRecentsSelectors,
};
